import { createContext } from "react";
export var UploadContext = createContext({
    open: function () { },
    isDragging: false,
    getDraggerProps: function () { return ({}); },
});
//# sourceMappingURL=UploadContext.js.map